const config = {
  MAX_ATTACHMENT_SIZE: 5000000,
  STRIPE_KEY:
    "pk_test_51LeeUHCtGC1ifAvUpUJlwSsENKJ1mfx1cH8lPlu5wVV2SZNA4UCRM0MlsLljLSEMPt3Lawey0b0F7thUwvucCAjl00Tfx8Y6Rl",
  SENTRY_DSN:
    "https://8cdf29fdbdc34de2881a4d7da60c84ce@o1396631.ingest.sentry.io/6720230",
  // Backend config
  s3: {
    REGION: process.env.REACT_APP_REGION,
    BUCKET: process.env.REACT_APP_BUCKET,
  },
  apiGateway: {
    REGION: process.env.REACT_APP_REGION,
    URL: process.env.REACT_APP_API_URL,
  },
  cognito: {
    REGION: process.env.REACT_APP_REGION,
    USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
    APP_CLIENT_ID: process.env.REACT_APP_USER_POOL_CLIENT_ID,
    IDENTITY_POOL_ID: process.env.REACT_APP_IDENTITY_POOL_ID,
  },
};

export default config;
